import { useState, useEffect } from 'react';
import '../../styles/slider.css';

const ResponsivePhotoSlider = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleCount, setVisibleCount] = useState(3);
  
  // Определяем количество видимых слайдов в зависимости от ширины экрана
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 576) {
        setVisibleCount(1);
      } else if (width < 768) {
        setVisibleCount(2);
      } else if (width < 992) {
        setVisibleCount(3);
      } else {
        setVisibleCount(4);
      }
      // Сбрасываем индекс при изменении количества видимых слайдов
      setCurrentIndex(0);
    };

    handleResize(); // Инициализация
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const maxIndex = Math.max(0, images.length - visibleCount);
  
  const goNext = () => {
    setCurrentIndex(prev => Math.min(prev + 1, maxIndex));
  };
  
  const goPrev = () => {
    setCurrentIndex(prev => Math.max(prev - 1, 0));
  };

  // Автопрокрутка каждые 5 секунд
  useEffect(() => {
    const timer = setInterval(() => {
      if (currentIndex < maxIndex) {
        // eslint-disable-next-line
        goNext();
      } else {
        setCurrentIndex(0); // Возврат к началу
      }
    }, 5000);
    return () => clearInterval(timer);
  }, [currentIndex, maxIndex]);

  const visibleImages = images.slice(currentIndex, currentIndex + visibleCount);
  
  return (
    <div className="responsive-slider">
      <button 
        className="slider-button prev" 
        onClick={goPrev}
        disabled={currentIndex === 0}
        aria-label="Previous"
      >
        &lt;
      </button>
      
      <div className="slider-container">
        {visibleImages.map((image, index) => (
          <div key={index} className="slide">
            <img 
              src={`https://inkochetkov.github.io/${image}`} 
              alt={`Slide ${currentIndex + index + 1}`} 
              className="slide-image"
              loading="lazy"
            />
          </div>
        ))}
      </div>
      
      <button 
        className="slider-button next" 
        onClick={goNext}
        disabled={currentIndex === maxIndex}
        aria-label="Next"
      >
        &gt;
      </button>

      <div className="slider-dots">
        {Array.from({ length: images.length - visibleCount + 1 }).map((_, index) => (
          <button
            key={index}
            className={`dot ${index === currentIndex ? 'active' : ''}`}
            onClick={() => setCurrentIndex(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};
export default ResponsivePhotoSlider;